import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const getFilteredPersonsByBranch = async ({ sucursal_id, desde, hasta, token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.PERSONA.LISTA_POR_SUCURSAL_FILTRADO}${sucursal_id}`, params: { desde, hasta }, extraHeaders: { token: token } });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default getFilteredPersonsByBranch;